import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Card, CardHeader, CardBody, CardFooter, Row, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import api from 'core/utils/api';
import { renderField } from 'core/utils/form';
import { required, minLength } from 'core/utils/validations';
import CardTitle from 'components/ui/CardTitle/CardTitle';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

const minLength5 = minLength(5);

const renderTitle = initialValues => (initialValues.id ? 'Edit client' : 'Add client');

class ClientForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.lookupZipCode = this.lookupZipCode.bind(this);
  }

  lookupZipCode(e, value = '') {
    if (!value.match(/^\d{5}$/)) { return; }
    this.setState({ zipLoading: true });
    api.get('/zip_lookups', { params: { zip_code: value } })
      .then((res) => {
        this.setState({ zipLoading: false });
        const { city, county, state } = res.data.zip_lookup;
        this.props.change('address.city', city);
        this.props.change('address.county', county);
        this.props.change('address.state.postal_code', state);
      });
  }



  render() {
    const { error, handleSubmit, invalid, submitting, initialValues } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <Card className="pageCard">
          <CardHeader>
            <CardTitle>{renderTitle(initialValues)}</CardTitle>
          </CardHeader>
          <CardBody className="padded">
            <Row>
              <Col xs="12" sm="6">
                <Field
                  name="first_name"
                  type="text"
                  label="First Name"
                  error={error}
                  component={renderField}
                  validate={[required]}
                />
              </Col>
              <Col xs="12" sm="6">
                <Field
                  name="last_name"
                  type="text"
                  label="Last Name"
                  error={error}
                  component={renderField}
                  validate={[required]}
                />
              </Col>
            </Row>

            <p className="lead">Property Address</p>
            <Row>
              <Col xs="12" sm="6">
                <Field
                  name="address.street"
                  type="text"
                  label="Street"
                  error={error}
                  component={renderField}
                  validate={[required]}
                />
              </Col>
              <Col xs="12" sm="6">
                <Field
                  name="address.street2"
                  type="text"
                  label="Street2"
                  error={error}
                  component={renderField}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" lg="3">
                <Field
                  name="address.city"
                  type="text"
                  label="City"
                  error={error}
                  component={renderField}
                  validate={[required]}
                  disabled
                />
              </Col>
              <Col xs="12" sm="6" lg="3">
                <Field
                  name="address.state.postal_code"
                  type="text"
                  label="State"
                  error={error}
                  component={renderField}
                  validate={[required]}
                  disabled
                />
              </Col>
              <Col xs="12" sm="6" lg="3">
                <Field
                  name="address.zip_code"
                  type="text"
                  label="Zip Code"
                  error={error}
                  component={renderField}
                  validate={[required, minLength5]}
                  onChange={this.lookupZipCode}
                  disabled={this.state.zipLoading}
                />
              </Col>
              <Col xs="12" sm="6" lg="3">
                <Field
                  name="address.county"
                  type="text"
                  label="County"
                  error={error}
                  component={renderField}
                  validate={[required]}
                  disabled
                />
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button
              color="primary"
              disabled={invalid || submitting}
            >
              Save
            </Button>
          </CardFooter>
        </Card>
      </Form>
    )
  }
}

ClientForm.propTypes = propTypes;

export default reduxForm({
  form: 'client',
})(ClientForm);



// WEBPACK FOOTER //
// ./src/features/client/ClientForm.js